import { acaoSobDemanda, telaSobDemanda } from '../../nucleo/paginas/TelaSobDemanda';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../../nucleo/api';
import type { ModuloWeb } from '../../nucleo/modulos';
import { CartaoIndicador } from '../../nucleo/ui/Estados';
import { dicionario } from './i18n';

/** F10: indicador de Cadastros no Início. */
function Indicadores() {
  const { t } = useTranslation('cadastros');
  const clientes = useQuery({ queryKey: ['cadastros', 'ind', 'clientes'], queryFn: () => api<{ itens: unknown[]; proximo: string | null }>('/api/v1/cadastros/parceiros?aba=clientes&limite=200') });
  const projetos = useQuery({ queryKey: ['cadastros', 'ind', 'projetos'], queryFn: () => api<{ itens: unknown[] }>('/api/v1/cadastros/projetos?status=em_andamento&limite=200') });
  // ROB-01: cartão do núcleo (§7.13): reticências só carregando; com a API em erro, traço e "Tentar de novo".
  return (
    <>
      <CartaoIndicador rotulo={t('indicadores.clientes')} valor={clientes.data ? `${clientes.data.itens.length}${clientes.data.proximo ? '+' : ''}` : null} consultas={[clientes]} />
      <CartaoIndicador rotulo={t('indicadores.projetosAndamento')} valor={projetos.data ? String(projetos.data.itens.length) : null} consultas={[projetos]} />
    </>
  );
}

const carregar0 = () => import('./ListaParceiros');
const carregar1 = () => import('./FichaParceiro');
const carregar2 = () => import('./Projetos');
const carregar3 = () => import('./Classificacao');

const AcaoParceiros = acaoSobDemanda(carregar0, 'AcaoParceiros');
const ListaParceiros = telaSobDemanda(carregar0, 'ListaParceiros');
const FichaParceiro = telaSobDemanda(carregar1, 'FichaParceiro');
const AcaoProjetos = acaoSobDemanda(carregar2, 'AcaoProjetos');
const FichaProjeto = telaSobDemanda(carregar2, 'FichaProjeto');
const Projetos = telaSobDemanda(carregar2, 'Projetos');
const Classificacao = telaSobDemanda(carregar3, 'Classificacao');

export const modulo: ModuloWeb = {
  slug: 'cadastros',
  menu: 'cadastros',
  dicionario,
  abas: [
    { rotulo: 'abas.empresas', caminho: 'empresas', elemento: <ListaParceiros key="empresas" aba="empresas" />, Acao: () => <AcaoParceiros rotulo="acoes.novaEmpresa" />, ordem: 1 },
    { rotulo: 'abas.projetos', caminho: 'projetos', elemento: <Projetos />, Acao: AcaoProjetos, ordem: 2 },
    { rotulo: 'abas.clientes', caminho: 'clientes', elemento: <ListaParceiros key="clientes" aba="clientes" />, Acao: () => <AcaoParceiros rotulo="acoes.novoCliente" />, ordem: 3 },
    { rotulo: 'abas.fornecedores', caminho: 'fornecedores', elemento: <ListaParceiros key="fornecedores" aba="fornecedores" />, Acao: () => <AcaoParceiros rotulo="acoes.novoFornecedor" />, ordem: 4 },
    { rotulo: 'abas.contatos', caminho: 'contatos', elemento: <ListaParceiros key="contatos" aba="contatos" />, Acao: () => <AcaoParceiros rotulo="acoes.novoContato" />, ordem: 5 },
    { rotulo: 'abas.classificacao', caminho: 'tags-e-setores', elemento: <Classificacao />, ordem: 6 },
  ],
  rotas: [
    { path: 'cadastros/parceiros/:id', element: <FichaParceiro /> },
    { path: 'cadastros/projetos/:id', element: <FichaProjeto /> },
  ],
  Indicadores,
  // ACH-09 (F9 e F10): ação primária do Início e passo "primeira ação" do tour.
  acaoInicio: { rotulo: 'acoes.novoCliente', rota: '/cadastros/clientes?novo=1', permissao: 'cadastros.criar', ordem: 1 },
};
